import { css } from '@/styled-system/css';

export const immersiveContainer = css({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  bg: 'hpxWhite',
  zIndex: 'zIndexLoader',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  animationName: 'fadeIn',
  animationDuration: '200ms',
  animationTimingFunction: 'ease-out',

  md: {
    position: 'absolute',
  },
});

export const immersiveContainerClosing = css({
  transitionProperty: 'transform',
  transitionDuration: '300ms', // Must match TRANSITION_DURATION_MS in ImmersiveContainer.tsx
  transitionTimingFunction: 'ease-out',
  transform: 'translateY(100vh)',
  '@supports (height: 100dvh)': {
    transform: 'translateY(100dvh)',
  },
});
